import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Directive,
  ElementRef,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Directive({
  selector: '[carouselItem]',
  standalone: true,
})
export class CarouselItemDirective {
  constructor(public tpl: TemplateRef<any>) {}
}

@Component({
  selector: 'app-carousel2',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule],
  styles: [
    `
      .carousel-moving {
        pointer-events: none;
      }
      .carousel-container {
        position: relative;
        .carousel-button {
          position: absolute;
          top: calc(50% - 20px);
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: white;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          border: 1px solid black;
          color: black;
          line-height: 18px;
          font-size: 18px;
          cursor: pointer;
        }
      }
      .carousel {
        overflow: hidden;
      }
    `,
  ],
  templateUrl: './carousel2.html',
})
export class Carousel2Widget {
  constructor(private cdRef: ChangeDetectorRef) {}
  observer: ResizeObserver;
  ngOnInit() {
    this.observer = new ResizeObserver((list) => {
      this.updateCurrentIndex();
    });
  }
  ngAfterViewInit() {
    this.observer.observe(this.carousel.nativeElement);
    this.updateCurrentIndex();
  }
  ngOnDestroy() {
    this.observer.disconnect();
  }

  @ViewChild('carousel') carousel: ElementRef<HTMLDivElement>;

  @ViewChildren('carouselItem') carouselItems: QueryList<ElementRef>;
  @ContentChildren(CarouselItemDirective)
  items: QueryList<CarouselItemDirective>;
  next() {
    let cl = this.carousel.nativeElement;
    let right = cl.scrollLeft + cl.clientWidth;
    let x = 0;
    for (let i of this.carouselItems) {
      let e = i.nativeElement as HTMLDivElement;
      let width = e.offsetWidth;
      if (x + width > right) {
        break;
      }
      x += width;
    }
    cl.scrollBy({
      left: x - cl.scrollLeft,
      top: 0,
      behavior: 'smooth',
    });
  }
  prev() {
    let cl = this.carousel.nativeElement;

    let left = cl.scrollLeft - cl.clientWidth;
    let x = 0;
    let offset = -cl.scrollLeft;
    if (left > 0) {
      for (let i of this.carouselItems) {
        let e = i.nativeElement as HTMLDivElement;
        let width = e.offsetWidth;
        if (x + width > left) {
          x += width;
          break;
        }
        x += width;
      }
      offset = x - cl.scrollLeft;
    }

    cl.scrollBy({
      left: offset,
      top: 0,
      behavior: 'smooth',
    });
  }

  atStart = true;
  atEnd = false;
  currentIndex = 0;

  dots: any[] = [];
  refreshDots() {
    let cl = this.carousel.nativeElement as HTMLElement;

    this.dots = [];
    length = Math.ceil(cl.scrollWidth / cl.clientWidth);
    for (let i = 0; i < length; i++) {
      this.dots.push({
        id: i,
      });
    }
  }
  updateCurrentIndex() {
    this.refreshDots();
    let cl = this.carousel.nativeElement as HTMLElement;
    let o = Math.floor(cl.scrollLeft / cl.clientWidth);
    console.log(`${cl.clientWidth} ${cl.scrollWidth}`);
    this.currentIndex = o;

    this.atStart = false;
    this.atEnd = false;
    if (cl.scrollLeft < 20) {
      this.atStart = true;
    }
    if (cl.scrollWidth - cl.scrollLeft <= cl.clientWidth + 20) {
      this.atEnd = true;
    }
    if (this.atEnd) {
      this.currentIndex = this.dots.length - 1;
    }
    this.cdRef.detectChanges();
  }

  mouseDown = false;

  startX: any;
  scrollLeft: any;
  startPageX: number;
  endPageX: number;

  startDragging(e, flag) {
    this.mouseDown = true;
    let cl = this.carousel.nativeElement as HTMLElement;

    this.startPageX = e.pageX;
    this.endPageX = e.pageX;
    this.startX = e.pageX - cl.offsetLeft;
    this.scrollLeft = cl.scrollLeft;
  }
  stopDragging(e, flag) {
    this.mouseDown = false;
    e.stopPropagation();
    e.preventDefault();
    e.cancelBubble = true;
  }
  onclick(e: MouseEvent) {

    const scroll = Math.abs(this.startPageX - this.endPageX);
    if (scroll < 10) {
      this.startPageX = 0;
      this.endPageX = 0;
      let ee = document.elementFromPoint(e.pageX, e.pageY) as HTMLElement;
      if (ee) {
        ee.click();
      }

    }
  }
  moveEvent(e) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    let cl = this.carousel.nativeElement as HTMLElement;

    this.endPageX = e.pageX;
    const x = e.pageX - cl.offsetLeft;
    const scroll = x - this.startX;

    cl.scrollLeft = this.scrollLeft - scroll;
  }
}
